import { observer } from 'mobx-react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { LeadRuleViewModel, TurnItOnForOptions } from '../../../../viewModels/leadrules';
import { RadioGroup } from '../../../../../web/components-v2/RadioGroup';
import { styleSheet } from '../../styles';
import { DrawerSection } from '../DrawerSection';
import { DailyActivityTeamPicker } from './DailyActivityTeamPicker';
import { IndividualPicker } from './IndividualPicker';
import { OptionRadio } from './OptionRadio';
import { VerticalPicker } from './VerticalPicker';

interface IProps {
	leadRule: LeadRuleViewModel;
	onSelect: (option: TurnItOnForOptions) => void;
}

export const TurnItOnFor: React.FC<IProps> = observer(({ leadRule, onSelect }) => {
	const [radio, setRadio] = useState<TurnItOnForOptions>(leadRule?.currentType ?? null);

	const handleRadio = (state: TurnItOnForOptions) => {
		onSelect(state);
		setRadio(state);
	};

	useEffect(() => {
		if (leadRule) {
			handleRadio(leadRule?.currentType);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [leadRule]);

	const isDailyTeamAvailable = !!leadRule?.userSession?.account?.isLevitateSalesCoffeeAccount;

	return (
		<DrawerSection title='Turn it on for'>
			<RadioGroup
				aria-label='Turn it on for'
				value={radio}
				onValueChange={handleRadio}
				styles={[styleSheet.radioGroup]}
			>
				<OptionRadio label='Everyone' value={TurnItOnForOptions.Everyone} />
				<OptionRadio label='Lead Pool(s)' value={TurnItOnForOptions.Vertical} />
				{isDailyTeamAvailable && <OptionRadio label='Daily Team(s)' value={TurnItOnForOptions.DailyActivityTeam} />}
				<OptionRadio label='Individual(s)' value={TurnItOnForOptions.Individual} />
			</RadioGroup>
			{radio === TurnItOnForOptions.Vertical && <VerticalPicker leadRule={leadRule} />}
			{isDailyTeamAvailable && radio === TurnItOnForOptions.DailyActivityTeam && (
				<DailyActivityTeamPicker leadRule={leadRule} />
			)}
			{radio === TurnItOnForOptions.Individual && <IndividualPicker leadRule={leadRule} />}
		</DrawerSection>
	);
});
